import { Typography } from '@mui/material';
import AppCard from './AppCard';

export default function FormSection({ title, children, sx }) {
    return (
        <AppCard sx={{ mb: 4, ...sx }}>
            {title && (
                <Typography variant="h4" sx={{ mb: 3, textAlign: 'left' }}>
                    {title}
                </Typography>
            )}
            {children}
        </AppCard>
    );
}
